import { FaMobileAlt, FaUniversity /*, FaWallet */ } from "react-icons/fa";

export const ACCOUNT_TYPES = {
  MOBILE_MONEY: "mobile",
  BANK: "bank",
  // WALLET: "wallet",
};

export const PAYMENT_TABS = [
  {
    label: "Mobile Money",
    value: "mpesa",
    icon: FaMobileAlt,
    accountType: ACCOUNT_TYPES.MOBILE_MONEY,
  },
  {
    label: "Bank Account",
    value: "bank",
    icon: FaUniversity,
    accountType: ACCOUNT_TYPES.BANK,
  },
  // {
  //   label: "Paykit Wallet",
  //   value: "paykit",
  //   icon: FaWallet,
  //   accountType: ACCOUNT_TYPES.WALLET,
  // },
];

export const BUTTON_CONFIG = {
  mpesa: {
    text: "Add Mobile Money Account",
    icon: FaMobileAlt,
    accountType: ACCOUNT_TYPES.MOBILE_MONEY,
  },
  bank: {
    text: "Add Bank Account",
    icon: FaUniversity,
    accountType: ACCOUNT_TYPES.BANK,
  },
  // paykit: {
  //   text: "Add Paykit Wallet",
  //   icon: FaWallet,
  //   accountType: ACCOUNT_TYPES.WALLET,
  // },
};

/**
 * Default empty state messages
 */
export const EMPTY_STATE_MESSAGES = {
  [ACCOUNT_TYPES.MOBILE_MONEY]: {
    title: "No Mobile Money Accounts",
    description: "You haven't added any mobile money accounts yet.",
  },
  [ACCOUNT_TYPES.BANK]: {
    title: "No Bank Accounts",
    description: "You haven't added any bank accounts yet.",
  },
  // [ACCOUNT_TYPES.WALLET]: {
  //   title: "No Wallet Accounts",
  //   description: "You haven't added any wallet accounts yet.",
  // },
};

export const ACCOUNT_FIELD_LABELS = {
  msisdn: "Phone Number",
  provider: "Provider",
  accountName: "Account Name",

  bankName: "Bank Name",
  accountNumber: "Account Number",
  branchCode: "Branch Code",
  swiftCode: "SWIFT Code",

  walletAccount: "Wallet Account",
  walletId: "Wallet ID",

  isDefaultPayout: "Default Payout",
};

export const ALERT_MESSAGES = {
  UPDATE_CONTACT_SUPPORT:
    "To update your payment details, please contact support.",
};
